<template><!-- 商品頁商品介紹區塊 -->
    <div id="intro">
        <div class="container">
            <h2 class="title">國旅的風險 都幫你想到了！</h2>
            <p class="text">跟著旅程投保，保費最低<span>74</span>元起</p>
            <div class="introList">
                <div class="introDiv">
                    <div class="title">境內班機<span class="blue">延誤</span><br>免擔心</div>
                    <img src="../../assets/pic1.svg" alt="推薦保旅平險：國內旅程延誤免擔心">
                    <p>飛機延誤，<strong>超過4hr提供定額2,000元</strong>。</p>
                </div>
                <div class="introDiv">
                    <div class="title">出發<span class="blue">一小時前</span><br>皆可投保</div>
                    <img src="../../assets/pic2.svg" alt="推薦保旅平險：出發一小時前皆可投保">
                    <p>網路投保就是快，5分鐘4步驟一次搞定。</p>
                </div>
                <div class="introDiv">
                    <div class="title">個人責任保險<br><span class="blue">最高60萬元</span></div>
                    <img src="../../assets/pic3.svg" alt="推薦保旅平險：個人責任保險最高60萬元">
                    <p>不小心弄壞民宿、飯店設施都有賠，自家寵物咬傷別人也有賠。</p>
                </div>
                <div class="introDiv">
                    <div class="title"><span class="blue">交通意外</span>事故<br>保障倍增</div>
                    <img src="../../assets/pic4.svg" alt="推薦保旅平險：交通意外事故保障倍增">
                    <p>自駕出遊上國道飛來橫禍，搭乘大眾運輸工具遇到車禍，<strong>最高理賠 200 萬元。</strong></p>
                </div>
                <div class="introDiv">
                    <div class="title"><span class="blue">租車意外</span>事故<br>免煩惱</div>
                    <img src="../../assets/pic5.svg" alt="國內旅平險推薦：租車意外事故免煩惱">
                    <p>自己受傷、車碰車損壞、對方人受傷、車損傷，保障通通有。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
#intro{
    background:$lightBlue;
    padding:74px 0;
    .text{
        span{
            color:$pink;
            font-size:36px;
            position: relative;
            top: 3px;
        }
        @media screen and (max-width: $pad) {
            font-size:20px;
        }
    }
    .container{
        margin:0 auto;
    }
    .introList{
        display: flex;
        margin:20px auto;
        @media screen and (max-width: $pad) {
            display:block;
        }
        .introDiv{width:17%;text-align: center;margin:0 20px;
            p{text-align:justify;margin-top:10px;}
            img{
                display: block;
                margin: 20px auto;
                border: 5px solid #005BAC;
                border-radius: 100%;
                box-sizing: border-box;
            }
            @media screen and (max-width: $medium) {
                img{width:100%}
            }
            @media screen and (max-width: $pad) {
                width:100%;
                overflow: hidden;
                clear:both;
                text-align: left;
                margin:20px 0;
                img{width:30%;float:left;margin-right:20px;}
                p{margin:0;
                }
            }
            @media screen and (max-width: $small){font-size:16px;
                img{width:35%;margin-top:10px;border:3px solid $blue-700;}
            }
            
        }

        .title{font-size:24px;padding:0;line-height:30px;color:$textColor;font-weight:500;
            .blue{font-weight:700;color:$blue-700}
            @media screen and (max-width: $pad) {
                display: inline-block;
                vertical-align: middle;
                margin-top:30px;
                width:58%;
                text-align: left;
                br{display:none;}
            }
            @media screen and (max-width: $pad) {
                margin-top:10%;
            }
            @media screen and (max-width: $small){
                margin-top:15px;
                font-size:1rem;
            }
        }
    }
}
</style>